<template>
    <div
        class="l-ss-c-sort"
        ref="sort-container"
        v-if="sortByFields.length !== 0">
        <dropdown
            :placement="$screen.isMobile ? 'right' : 'left'"
            dropdown-body-class="l-ss-c-sort-dropdown"
            ref="dropdown">
            <button
                class="l-ss-c-sort-button">
                <i v-html="iconSort"></i>
                <span>{{ sortTitle }}</span>
            </button>
            <template #dropdown>
                <app-radio-button
                    v-for="item in sortByFields"
                    :key="item.title"
                    :label="item.title"
                    :value="activeSortField ? activeSortField.title : null"
                    @change="handleSort($event, item)">
                    {{ item.title }}
                </app-radio-button>
            </template>
        </dropdown>
    </div>
</template>

<script>
    import AppRadioButton from '@/core/components/common/app-radio-button.vue';

    import iconSort from '@/core/assets/images/icons/sort-icon.svg';

    import isObject from '@/core/helpers/is-object';
    import Dropdown from '@/core/components/common/dropdown.vue';

    export default {
        components: { Dropdown, AppRadioButton },
        props: ['sortBy', 'sortDest'],
        computed: {
            iconSort() {
                return iconSort;
            },
            sortByFields() {
                const sortFields = [
                    ...process.env.SEARCH_BOOSTER_QUERY_SORT_BY_FIELDS.split(','),
                    ...Object.keys(this.$configuration.additionalSort),
                ];

                const disableSortOptions = this.$configuration.disableSortOptions;

                return sortFields.reduce((memo, sortBy) => {
                    let locale = this.$t(`sort.fields.${sortBy}`);
                    let sortParam = null;
                    if (!isObject(locale)) {
                        locale = this.$configuration.additionalSort[sortBy];
                        sortParam = `param.${locale.param}`;
                    }
                    return [].concat(memo, Object.keys(locale).filter(el => el !== 'param').map((sortDest) => {
                        return {
                            title: locale[sortDest],
                            sortKey: sortBy,
                            sortBy: sortParam ? sortParam : sortBy,
                            sortDest,
                        };
                    }));
                }, [])
                    .filter(option => {
                        return !disableSortOptions?.includes(option.sortBy) && !disableSortOptions?.includes('all');
                    })
                    .sort((a) => {
                        if (a.sortBy === '_score') {
                            return -1;
                        }
                    });
            },
            activeSortField() {
                const activeSortField = this.sortByFields.find(item => item.sortBy === this.sortBy && item.sortDest === this.sortDest);

                return activeSortField || this.sortByFields.find(item => item.sortBy === '_score');
            },
            sortTitle() {
                return this.activeSortField
                    ? this.activeSortField.title
                    : this.$t('sort.empty-text');
            },
        },
        methods: {
            handleSort(eventData, sort) {
                this.$refs.dropdown.closeDropdown();
                this.$emit('sort-change', sort);
                this.$emit('result-sort-click', { type: 'resultSort', event: eventData.event, selectSort: sort.title });
            },
        },
    };
</script>
